import { render, staticRenderFns } from "./ModalObjectAddPerson.vue?vue&type=template&id=0f20ff8e&scoped=true"
import script from "./ModalObjectAddPerson.vue?vue&type=script&lang=js"
export * from "./ModalObjectAddPerson.vue?vue&type=script&lang=js"
import style0 from "./ModalObjectAddPerson.vue?vue&type=style&index=0&id=0f20ff8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f20ff8e",
  null
  
)

export default component.exports